/* assets/wc-landing.js */
(function(){
  'use strict';
  function initReveal(){
    var els=document.querySelectorAll('.wc-rev');
    if(!els.length)return;
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('wc-in');io.unobserve(e.target);}});
      },{threshold:0.07,rootMargin:'0px 0px -24px 0px'});
      els.forEach(function(el){io.observe(el);});
    } else { els.forEach(function(el){el.classList.add('wc-in');}); }
  }
  function initFaq(){
    document.querySelectorAll('.wc-faq__item').forEach(function(item){
      var btn=item.querySelector('.wc-faq__q');
      if(!btn)return;
      btn.addEventListener('click',function(){
        var open=item.classList.contains('wc-faq--open');
        document.querySelectorAll('.wc-faq__item').forEach(function(i){i.classList.remove('wc-faq--open');});
        if(!open)item.classList.add('wc-faq--open');
      });
    });
  }
  function initTabs(){
    document.querySelectorAll('.wc-tab').forEach(function(tab){
      tab.addEventListener('click',function(){
        var row=tab.closest('.wc-tabs');
        if(row)row.querySelectorAll('.wc-tab').forEach(function(t){t.classList.remove('wc-tab--active');});
        tab.classList.add('wc-tab--active');
      });
    });
  }
  function initAnchors(){
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click',function(e){
        var t=document.querySelector(a.getAttribute('href'));
        if(!t)return;
        e.preventDefault();
        window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-80,behavior:'smooth'});
      });
    });
  }
  document.addEventListener('DOMContentLoaded',function(){
    initReveal();initFaq();initTabs();initAnchors();
  });
})();
